import { defineMessages } from 'react-intl';

export default defineMessages<string, any>({
  DegreeProgram: { id: 'DegreeProgram', defaultMessage: 'Degree Program' },
  File: { id: 'File', defaultMessage: 'File' },
  Occasion: { id: 'Occasion', defaultMessage: 'Occasion' },
  InfoEvent: { id: 'InfoEvent', defaultMessage: 'Info Event' },
  FHNWEvent: { id: 'FHNWEvent', defaultMessage: 'FHNW Event' },
  ConEduEvent: { id: 'ConEduEvent', defaultMessage: 'ConEdu Event' },
  Contact: { id: 'Contact', defaultMessage: 'Contact' },
  Module: { id: 'Module', defaultMessage: 'Module' },
  FHNWNews: { id: 'FHNWNews', defaultMessage: 'FHNW News' },
  Location: { id: 'Location', defaultMessage: 'Location' },
  Project: { id: 'Project', defaultMessage: 'Project' },
  ContinuingEducation: {
    id: 'ContinuingEducation',
    defaultMessage: 'Continuing Education',
  },
  Snippet: { id: 'Snippet', defaultMessage: 'Snippet' },
  Story: { id: 'Story', defaultMessage: 'Story' },
  TeamContact: { id: 'TeamContact', defaultMessage: 'Team Contact' },
  // Solr search results carry the FTI title as @type, not the portal_type
  'Team Contact': { id: 'Team Contact', defaultMessage: 'Team Contact' },
  University: { id: 'University', defaultMessage: 'University' },
  Specialization: { id: 'Specialization', defaultMessage: 'Specialization' },
  Topic: { id: 'Topic', defaultMessage: 'Topic' },
  ResearchArea: { id: 'ResearchArea', defaultMessage: 'Research Area' },
  ResearchFocus: { id: 'ResearchFocus', defaultMessage: 'Research Focus' },
  Service: { id: 'Service', defaultMessage: 'Service' },
});
